
















































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import {Impressions, logout} from '@/api';
import ImpressionComponent from '@/components/ImpressionComponent.vue';
import AdComponent from '@/components/AdComponent.vue';

@Component({
    components: {
        'v-impression': ImpressionComponent,
        'ad': AdComponent,
    },
})
export default class ImpressionsListView extends Vue {
    private impList: Impressions[] = [];
    private isLoading: boolean = false;

    private mounted() {
        this.load();
    }

    private load() {
        window.scrollTo(0, 0);
        const user = firebase.auth().currentUser;
        if (user != null) {
            this.impList = [];
            this.isLoading = true;
            const uid = user.uid;
            // const imageRef = firebase.database().ref('impressions');
            const imageRef = firebase.firestore().collection('impressions');
            imageRef.where('user', '==', uid).orderBy('created_at', 'desc').get()
                .then((snapshot) => {
                    if (!snapshot.empty)  {
                        snapshot.forEach((doc) => {
                            this.impList.push(doc.data() as Impressions);
                        });
                        this.isLoading = false;
                    } else {
                        this.isLoading = false;
                        this.$router.push({name: 'book_add'});
                        console.log('not found');
                    }
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.log(err);
                });
        } else {
            logout();
        }
    }

}
